export default __webpack_public_path__ + "static/media/end_disconnect.77fde24e.svg";